var a="\n    particlePos = (matrix_model * vec4(particlePos, 1.0)).xyz;\n";export{a as default};
